import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-img-header',
  templateUrl: './img-header.component.html',
  styleUrls: ['./img-header.component.css']
})
export class ImgHeaderComponent implements OnInit {
  @Input() imgUrl: string;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/img-header/img-header.component.ts